import Layout from '@/layout'
const asyncInoutStockDetailRoutes =
{
  path: '/stock/inoutStockDetail',
  component: Layout,
  redirect: 'noredirect',
  name: '出入库明细统计',
  funcPerms: 'stock:inoutStockDetail',
  meta: {
    title: '出入库明细统计',
    icon: 'inoutStockDetail',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'inoutStockDetail/index',
      component: () => import('@/views/oa/inoutStockDetail/index.vue'),
      funcPerms: 'stock:inoutStockDetail',
      name: 'inoutStockDetail',
      meta: {
        title: '出入库明细统计',
        icon: 'inoutStockDetail',
        affix: false,
        noCache: true
      }
    }
  ]
}
export default asyncInoutStockDetailRoutes
